<div class="dep-table-container pop-datatable">
  <p-table #dt
           [value]="departmentEstimates"
           [globalFilterFields]="['department.code', 'department.description']"
           frozenWidth="11em"
           [scrollable]="true"
           scrollHeight="flex"
           scrollDirection="both">

    <ng-template pTemplate="header">
      <tr>
        <th class="dep-table-top-header"
            colspan="1"
            pFrozenColumn>
          <div class="pop-text-align-left">
            <i class="far fa-search"></i>
            <input class="input-filter"
                   type="text"
                   pInputText
                   size="50"
                   (input)="filterTable(dt, $event.target)" />
          </div>
        </th>
        <th class="dep-table-top-header pop-text-align-center"
            [attr.colspan]="colspanClassifications"
            [hidden]="colspanClassifications === 0"
            translate="TOOLBAR.CLASS"></th>
        <th class="dep-table-top-header"
            colspan="4"
            translate="HEADER.HOURS"></th>
        <th class="dep-table-top-header"
            [attr.colspan]="4+colspanInternalFees"
            *ngIf="activateInternalFees"
            translate="HEADER.INTERNAL_FEES"></th>
        <th class="dep-table-top-header"
            colspan="3"
            translate="HEADER.EXPENSE"></th>
        <th class="dep-table-top-header"
            colspan="3"
            translate="HEADER.TOTALS"></th>
      </tr>
      <tr>
        <th class="dep-table-pro-header pop-border-right"
            pFrozenColumn>
          {{ departmentLabel }}
        </th>
        <th class="class-header dep-alignCenter"
            [hidden]="colspanClassifications === 0"
            *ngFor="
            let classificationEstimate of currentEstimate?.classificationEstimates
          "
            matTooltip="{{ classificationEstimate?.classification?.description }}"
            position="above">
          <div class="pop-display-flex pop-flex-direction-column">
            <span>{{ classificationEstimate?.classification?.code }}</span>
            <span class="dep-class-description">
              {{
              classificationEstimate?.classification?.description
              }}
            </span>
          </div>
        </th>
        <th class="dep-table-hours-header dep-alignCenter"
            translate="HEADER.HOURS"></th>
        <th class="total-cost-header pop-border-left dep-alignCenter">
          {{ "TABLE.COSTING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="total-s-header dep-alignCenter">
          {{ "TABLE.SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="total-s-header dep-alignCenter pop-border-right">
          {{ "TABLE.TOTAL_SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>

        <ng-container *ngIf="activateInternalFees">
          <th class="class-header dep-alignCenter"
              [hidden]="colspanInternalFees === 0"
              *ngFor="
            let internalResourceEstimate of currentEstimate?.internalResourceEstimates
          "
              matTooltip="{{ internalResourceEstimate?.internalResource?.description }}"
              position="above">
            <div class="pop-display-flex pop-flex-direction-column">
              <span>{{ internalResourceEstimate?.internalResource?.code }}</span>
              <span class="dep-internalfee-description">
                {{
                internalResourceEstimate?.internalResource?.description
                }}
              </span>
            </div>
          </th>
          <th class="costs-header pop-border-left dep-alignCenter"
              translate="HEADER.QUANTITY"></th>
          <th class="costs-header dep-alignCenter">
            {{ "TABLE.COSTING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th class="total-s-header dep-alignCenter">
            {{ "TABLE.SELLING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
          <th class="total-s-header dep-alignCenter">
            {{ "TABLE.TOTAL_SELLING" | translate }} ({{ functionalCurrencySymbol }})
          </th>
        </ng-container>

        <th class="costs-header pop-border-left dep-alignCenter">
          {{ "TABLE.COSTING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="total-s-header dep-alignCenter">
          {{ "TABLE.SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="total-s-header dep-alignCenter">
          {{ "TABLE.TOTAL_SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="costing-header pop-text-align-center pop-border-left dep-alignCenter">
          {{ "TABLE.COSTING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="selling-header dep-alignCenter">
          {{ "TABLE.SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
        <th class="final-selling-header dep-alignCenter">
          {{ "TABLE.TOTAL_SELLING" | translate }} ({{ functionalCurrencySymbol }})
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body"
                 let-rowData>
      <tr>
        <td class="dep-table-list"
            pFrozenColumn>
          {{ rowData.department?.code }} &#8901;
          {{ rowData.department?.description }}
        </td>
        <td class="dep-hour-list"
            *ngFor="
            let classificationEstimate of currentEstimate.classificationEstimates
          ">
          {{ rowData | classHours: classificationEstimate.id }}
        </td>
        <td class="dep-total-hour-list">
          {{ rowData | departmentHours }}
        </td>
        <td class="dep-hour-list pop-text-align-right">
          {{ rowData | hoursCost | number: "1.2-2":currentLang }}
        </td>
        <td class="dep-hour-list pop-text-align-right">
          {{ rowData | hoursBillable | number: "1.2-2":currentLang }}
        </td>
        <td class="dep-hour-list pop-text-align-right pop-border-right">
          {{ rowData | hoursBillableFinal | number: "1.2-2":currentLang }}
        </td>

        <ng-container *ngIf="activateInternalFees">
          <td class="dep-hour-list pop-text-align-center"
              *ngFor="
            let internalResourceEstimate of currentEstimate.internalResourceEstimates
          ">
            {{ rowData | internalFeeQuantity: internalResourceEstimate.id }}
          </td>
          <td class="dep-total-hour-list pop-text-align-center">
            {{ rowData | internalFeeQuantity }}
          </td>
          <td class="dep-hour-list pop-text-align-right">
            {{ rowData | internalFeeCost | number: "1.2-2":currentLang }}
          </td>
          <td class="dep-hour-list pop-text-align-right">
            {{ rowData | internalFeeBillable | number: "1.2-2":currentLang }}
          </td>
          <td class="dep-hour-list pop-text-align-right">
            {{ rowData | internalFeeBillableFinal | number: "1.2-2":currentLang }}
          </td>
        </ng-container>


        <td class="dep-table-costing-list pop-text-align-right">
          {{ rowData | expenseCost | number: "1.2-2":currentLang }}
        </td>
        <td class="dep-hour-list pop-text-align-right">
          {{ rowData | expenseBillable | number: "1.2-2":currentLang }}
        </td>
        <td class="dep-hour-list pop-text-align-right">
          {{ rowData | expenseBillableFinal | number: "1.2-2":currentLang }}
        </td>
        <td class="dep-table-costing-list pop-text-align-right">
          {{
          (rowData | hoursCost) + (rowData | expenseCost) + (rowData | internalFeeCost)
          | number: "1.2-2":currentLang
          }}
        </td>
        <td class="dep-hour-list pop-text-align-right">
          {{
          (rowData | hoursBillable) + (rowData | expenseBillable) + (rowData | internalFeeBillable)
          | number: "1.2-2":currentLang
          }}
        </td>
        <td class="dep-hour-list pop-text-align-right">
          {{
          (rowData | hoursBillableFinal) + (rowData | expenseBillableFinal) + (rowData | internalFeeBillableFinal)
          | number: "1.2-2":currentLang
          }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
